import React, {Component} from 'react';
import PropTypes from 'prop-types';
import InputField from '../../components/new-ui/input_field';
import Dropdown from '../../forecast-app/shared/components/dropdowns/dropdown';
import {BUTTON_COLOR, BUTTON_STYLE, permissions} from '../../constants';
import {createToast} from '../../forecast-app/shared/components/toasts/another-toast/toaster';
import {dispatch, EVENT_ID} from '../event_manager';
import {createPerson} from '../../components/scheduling/scheduling_mutations';
import CreatePersonMutationModern from '../../mutations/create_person_mutation.modern';
import CreateProjectPersonMutation from '../../mutations/create_project_person_mutation';
import {injectIntl} from 'react-intl';
import Button from '../../forecast-app/shared/components/buttons/button/button';
import Util from '../../forecast-app/shared/util/util';
import {MODAL_TYPE, showModal} from '../../forecast-app/shared/components/modals/generic_modal_conductor';
import {Link} from 'react-router-dom';
import {
	getSelectableProfiles,
	personIsAdmin,
	personIsClientUser,
	personIsVirtualUser,
} from '../../forecast-app/shared/util/PermissionsUtil';

class AddTeamMemberModalContent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			name: '',
			email: '',
			selectedRole: null,
			selectedPermission: null,
			selectedProfile: null,
			showEmailValidationError: false,
			emailValidationErrorMessage: '',
			showNameValidationError: false,
			nameValidationErrorMessage: '',
			canSendRequest: true,
			createdPersons: [],
		};
	}

	checkEmailValidity(isValid) {
		this.setState({
			showEmailValidationError: !isValid,
			emailValidationErrorMessage: !isValid
				? this.props.intl.formatMessage({id: 'settings_team.invalid-email'})
				: this.props.intl.formatMessage({id: 'common.field-cannot-be-empty'}),
		});
	}

	onCreatePersonSuccess(result) {
		if (result.createPerson.errors && result.createPerson.errors.length > 0) {
			let nameErrorText = '';
			let emailErrorText = '';
			for (let error of result.createPerson.errors) {
				switch (error) {
					case 'FIRST_NAME_TOO_LONG':
						nameErrorText = this.props.intl.formatMessage({id: 'errors.name-too-long'});
						break;
					case 'LAST_NAME_TOO_LONG':
						nameErrorText = this.props.intl.formatMessage({id: 'errors.name-too-long'});
						break;
					case 'ACCOUNT_ALREADY_EXIST':
						emailErrorText = this.props.intl.formatMessage({id: 'settings_team.duplicate-email'});
						break;
					case 'MAIL_ADDRESS_TOO_LONG':
						emailErrorText = error;
						break;
					case 'EMAIL_INVALID':
						emailErrorText = this.props.intl.formatMessage({id: 'login.incorrect_email'});
						break;
					default:
						break;
				}
			}
			this.setState({
				showEmailValidationError: emailErrorText.length > 0,
				emailValidationErrorMessage: this.props.intl.formatMessage({id: 'settings_team.duplicate-email'}),
				showNameValidationError: nameErrorText.length > 0,
				nameValidationErrorMessage: nameErrorText,
				canSendRequest: true,
			});
		} else {
			const name = result.createPerson.person.node.firstName + ' ' + result.createPerson.person.node.lastName;
			this.state.createdPersons.push({
				name,
				email: result.createPerson.person.node.email,
				role: this.state.selectedRole,
				permission: this.state.selectedPermission,
				profile: this.state.selectedProfile,
			});
			this.setState({createdPersons: this.state.createdPersons});
			if (this.props.personInvited) {
				this.props.personInvited(result.createPerson.person.node);
			}
			if (this.props.projectId) {
				Util.CommitMutation(
					CreateProjectPersonMutation,
					{
						projectId: this.props.projectId,
						projectGroupId: this.props.projectGroupId,
						personId: result.createPerson.person.node.id,
						roleId: this.state.selectedRole || undefined,
					},
					this.onCreateProjectPersonSuccess()
				);
			} else {
				this.onCreateProjectPersonSuccess();
			}
			dispatch(EVENT_ID.SCHEDULING_MODAL_MUTATION_SUCCESS, result);
		}
	}

	onCreateProjectPersonSuccess() {
		this.setState({
			name: '',
			email: '',
		});
		createToast({
			duration: 5000,
			message: personIsVirtualUser(this.state.selectedProfile.profile)
				? this.props.intl.formatMessage({id: 'add_team_member_modal.team-member-added'})
				: this.props.intl.formatMessage({id: 'add_team_member_modal.team-member-invited'}),
		});
		this.setState({canSendRequest: true});
	}

	handleInputChange(property, value) {
		this.setState({
			[property]: value,
			showNameValidationError: false,
			showEmailValidationError: false,
		});
		/* 		this.setState({
			showEmailValidationError: emailErrorText.length > 0,
			emailValidationErrorMessage: this.props.intl.formatMessage({id: 'settings_team.duplicate-email'}),
			showNameValidationError: nameErrorText.length > 0,
			nameValidationErrorMessage: nameErrorText,
			canSendRequest: true
		}); */
	}

	handleSelectChange(property, option) {
		this.setState({
			[property]: option ? option.value : null,
			showUserTypeValidationError: false,
			userTypeValidationErrorMessage: '',
		});
	}

	handleProfileChange(profileOption) {
		this.setState({
			selectedProfile: profileOption || null,
			showUserTypeValidationError: false,
			userTypeValidationErrorMessage: '',
		});
	}

	clearValidation() {
		this.setState({
			showUserTypeValidationError: false,
			userTypeValidationErrorMessage: '',
		});
	}

	createPersonFromProfile() {
		const name = this.state.name;
		const emailRequired = this.state.selectedProfile && !personIsVirtualUser(this.state.selectedProfile.profile);
		const emailValid = !this.state.showEmailValidationError;
		const fullName = name.trim();
		let first;
		let last;
		if (fullName.indexOf(' ') <= 0) {
			first = fullName;
			last = '';
		} else {
			first = fullName.substr(0, fullName.indexOf(' ')).trim();
			last = fullName.substr(fullName.indexOf(' ') + 1).trim();
		}

		const showNameValidationError = name === '' || name === null;
		const showEmailValidationError = !emailValid || (emailRequired && !this.state.email);
		const showUserTypeValidationError = this.state.selectedProfile == null;

		const nameValidationErrorMessage =
			name === '' || name === null ? this.props.intl.formatMessage({id: 'common.field-cannot-be-empty'}) : '';
		const emailValidationErrorMessage = !emailValid
			? this.state.emailValidationErrorMessage
			: this.props.intl.formatMessage({id: 'common.field-cannot-be-empty'});
		const userTypeValidationErrorMessage = showUserTypeValidationError
			? this.props.intl.formatMessage({id: 'common.field-cannot-be-empty'})
			: '';
		this.setState({
			showNameValidationError,
			nameValidationErrorMessage,
			showEmailValidationError,
			emailValidationErrorMessage,
			showUserTypeValidationError,
			userTypeValidationErrorMessage,
		});

		if (showNameValidationError || showEmailValidationError || showUserTypeValidationError || !this.state.canSendRequest) {
			return;
		}

		this.setState({canSendRequest: false});

		const isScheduling = window.location.pathname.includes('scheduling');

		const data = {
			email: this.state.email === '' ? null : this.state.email,
			firstName: first,
			lastName: last,
			roleId: this.state.selectedRole || undefined,
			profileId: this.state.selectedProfile.value,
			invited: personIsVirtualUser(this.state.selectedProfile.profile) ? false : this.state.email !== '',
		};

		if (isScheduling) {
			if (
				name !== null &&
				name !== '' &&
				this.state.canSendRequest &&
				!(emailRequired && !emailValid) &&
				!(emailRequired && !this.state.email)
			) {
				if (personIsAdmin(this.state.selectedProfile.profile)) {
					showModal({
						type: MODAL_TYPE.CONFIRM_PASSWORD_MODAL,
						schedulingCreatePerson: createPerson,
						mutationName: 'createPerson',
						data,
						onSuccess: this.onCreatePersonSuccess.bind(this),
						onFailure: result => {
							this.setState({canSendRequest: true});
						},
					});
				} else {
					createPerson(data, this.onCreatePersonSuccess.bind(this));
				}
			}
		} else {
			if (personIsAdmin(this.state.selectedProfile.profile)) {
				showModal({
					type: MODAL_TYPE.CONFIRM_PASSWORD_MODAL,
					mutation: CreatePersonMutationModern,
					mutationName: 'createPerson',
					data: {companyId: this.props.viewer.company.id, ...data},
					onSuccess: this.onCreatePersonSuccess.bind(this),
					onFailure: result => {
						this.setState({canSendRequest: true});
					},
				});
			} else {
				Util.CommitMutation(
					CreatePersonMutationModern,
					{companyId: this.props.viewer.company.id, ...data},
					this.onCreatePersonSuccess.bind(this)
				);
			}
		}
	}

	// Deprecated with release of new profiles
	createPerson() {
		const name = this.state.name;
		const emailRequired = this.state.selectedPermission !== permissions[0].value;
		const emailValid = !this.state.showEmailValidationError;
		const fullName = name.trim();
		let first;
		let last;
		if (fullName.indexOf(' ') <= 0) {
			first = fullName;
			last = '';
		} else {
			first = fullName.substr(0, fullName.indexOf(' ')).trim();
			last = fullName.substr(fullName.indexOf(' ') + 1).trim();
		}

		const showNameValidationError = name === '' || name === null;
		const showEmailValidationError = !emailValid || (emailRequired && !this.state.email);
		const showUserTypeValidationError = this.state.selectedPermission == null;

		const nameValidationErrorMessage =
			name === '' || name === null ? this.props.intl.formatMessage({id: 'common.field-cannot-be-empty'}) : '';
		const emailValidationErrorMessage = !emailValid
			? this.state.emailValidationErrorMessage
			: this.props.intl.formatMessage({id: 'common.field-cannot-be-empty'});
		const userTypeValidationErrorMessage = showUserTypeValidationError
			? this.props.intl.formatMessage({id: 'common.field-cannot-be-empty'})
			: '';
		this.setState({
			showNameValidationError,
			nameValidationErrorMessage,
			showEmailValidationError,
			emailValidationErrorMessage,
			showUserTypeValidationError,
			userTypeValidationErrorMessage,
		});

		if (showNameValidationError || showEmailValidationError || showUserTypeValidationError || !this.state.canSendRequest) {
			return;
		}

		this.setState({canSendRequest: false});

		const isScheduling = window.location.pathname.includes('scheduling');

		const data = {
			email: this.state.email === '' ? null : this.state.email,
			firstName: first,
			lastName: last,
			roleId: this.state.selectedRole || undefined,
			userType: this.state.selectedPermission,
			invited: this.state.selectedPermission === 'NO_LOGIN' ? false : this.state.email !== '',
		};

		if (isScheduling) {
			if (
				name !== null &&
				name !== '' &&
				this.state.canSendRequest &&
				!(emailRequired && !emailValid) &&
				!(emailRequired && !this.state.email)
			) {
				if (this.state.selectedPermission === 'ADMIN') {
					showModal({
						type: MODAL_TYPE.CONFIRM_PASSWORD_MODAL,
						schedulingCreatePerson: createPerson,
						mutationName: 'createPerson',
						data,
						onSuccess: this.onCreatePersonSuccess.bind(this),
						onFailure: result => {
							this.setState({canSendRequest: true});
						},
					});
				} else {
					createPerson(data, this.onCreatePersonSuccess.bind(this));
				}
			}
		} else {
			if (this.state.selectedPermission === 'ADMIN') {
				showModal({
					type: MODAL_TYPE.CONFIRM_PASSWORD_MODAL,
					mutation: CreatePersonMutationModern,
					mutationName: 'createPerson',
					data: {companyId: this.props.viewer.company.id, ...data},
					onSuccess: this.onCreatePersonSuccess.bind(this),
					onFailure: result => {
						this.setState({canSendRequest: true});
					},
				});
			} else {
				Util.CommitMutation(
					CreatePersonMutationModern,
					{companyId: this.props.viewer.company.id, ...data},
					this.onCreatePersonSuccess.bind(this)
				);
			}
		}
	}

	handleLinkClick() {
		if (this.props.closeModal) {
			this.props.closeModal();
		}
	}

	getSeatsInfoWithProfile() {
		const {formatMessage} = this.props.intl;

		const isChargebeeCustomer = this.props.viewer.company.isChargebeeCustomer;

		// All active
		const activated = this.props.viewer.company.allPersons.edges.filter(person => person.node.active).map(p => p.node);

		const selectedVirtualUser = this.state.selectedProfile ? personIsVirtualUser(this.state.selectedProfile.profile) : null;

		if (isChargebeeCustomer) {
			// Seats from chargebee subscription
			const userSeats = this.props.viewer.company.subscription
				? this.props.viewer.company.subscription.seats
				: this.props.viewer.company.userSeats;
			const virtualSeats = this.props.viewer.company.subscription
				? this.props.viewer.company.subscription.virtualSeats
				: this.props.viewer.company.virtualSeats;

			// How many active seats the acount actual has
			const actualUserSeats = activated.filter(
				person => !personIsVirtualUser(person) && !personIsClientUser(person)
			).length;
			const actualVirtualSeats = activated.filter(person => personIsVirtualUser(person)).length;

			// If account is going above its seats
			const overUserCap = userSeats <= actualUserSeats;

			const freeVirtualUsers = this.props.viewer.company.planAddons.some(pa => pa === 'free_virtual_users');
			const overVirtualUserCap = !freeVirtualUsers && virtualSeats <= actualVirtualSeats;

			if (overUserCap && selectedVirtualUser === false) {
				return (
					<div className={'seats-count warning'}>
						<div className={'seats-text'}>
							<div className={'seats-warning-text'}>
								{formatMessage(
									{id: 'team_modal.seats_warning_action_prevented'},
									{type: ' ', max: `(${userSeats})`}
								)}
								<Link onClick={this.handleLinkClick.bind(this)} to="/settings/subscription">
									{formatMessage({id: 'team_modal.seats_warning_subscription_page'})}
								</Link>
							</div>
						</div>
					</div>
				);
			}

			if (overVirtualUserCap && selectedVirtualUser) {
				return (
					<div className={'seats-count warning'}>
						<div className={'seats-text'}>
							<div className={'seats-warning-text'}>
								{formatMessage(
									{id: 'team_modal.seats_warning_action_prevented'},
									{type: 'virtual ', max: `(${virtualSeats})`}
								)}
								<Link onClick={this.handleLinkClick.bind(this)} to="/settings/subscription">
									{formatMessage({id: 'team_modal.seats_warning_subscription_page'})}
								</Link>
							</div>
						</div>
					</div>
				);
			}

			return (
				<div className={'seats-count info'}>
					<div className={'seats-text'}>
						{formatMessage({id: 'team_modal.seats_info'}, {amount: actualUserSeats, total: userSeats})}
					</div>
					{!freeVirtualUsers ? (
						<div className={'seats-text'}>
							{formatMessage(
								{id: 'team_modal.virtual_seats_info'},
								{amount: actualVirtualSeats, total: virtualSeats}
							)}
						</div>
					) : null}
				</div>
			);
		} else if (selectedVirtualUser) {
			return (
				<div className={'seats-count warning'}>
					<div className={'seats-text'}>
						<div className={'seats-text'}>
							<div className={'seats-warning-text'}>
								{formatMessage({id: 'add_team_member_modal.disclaimer'})}
							</div>
						</div>
					</div>
				</div>
			);
		}
	}

	// Deprecated with release of new permissions
	getSeatsInfo() {
		const {formatMessage} = this.props.intl;

		const isChargebeeCustomer = this.props.viewer.company.isChargebeeCustomer;

		// All active
		const activated = this.props.viewer.company.allPersons.edges.filter(person => person.node.active).map(p => p.node);

		if (isChargebeeCustomer) {
			// Seats from chargebee subscription
			const userSeats = this.props.viewer.company.subscription
				? this.props.viewer.company.subscription.seats
				: this.props.viewer.company.userSeats;
			const virtualSeats = this.props.viewer.company.subscription
				? this.props.viewer.company.subscription.virtualSeats
				: this.props.viewer.company.virtualSeats;

			// How many active seats the acount actual has
			const actualUserSeats = activated.filter(
				person => person.userType !== 'NO_LOGIN' && person.userType !== 'CLIENT'
			).length;
			const actualVirtualSeats = activated.filter(person => person.userType === 'NO_LOGIN' && !person.client).length;

			// If account is going above its seats
			const overUserCap = userSeats <= actualUserSeats;

			const freeVirtualUsers = this.props.viewer.company.planAddons.some(pa => pa === 'free_virtual_users');
			const overVirtualUserCap = !freeVirtualUsers && virtualSeats <= actualVirtualSeats;

			if (overUserCap && this.state.selectedPermission && this.state.selectedPermission !== 'NO_LOGIN') {
				return (
					<div className={'seats-count warning'}>
						<div className={'seats-text'}>
							<div className={'seats-warning-text'}>
								{formatMessage(
									{id: 'team_modal.seats_warning_action_prevented'},
									{type: ' ', max: `(${userSeats})`}
								)}
								<Link onClick={this.handleLinkClick.bind(this)} to="/settings/subscription">
									{formatMessage({id: 'team_modal.seats_warning_subscription_page'})}
								</Link>
							</div>
						</div>
					</div>
				);
			}

			if (overVirtualUserCap && this.state.selectedPermission && this.state.selectedPermission === 'NO_LOGIN') {
				return (
					<div className={'seats-count warning'}>
						<div className={'seats-text'}>
							<div className={'seats-warning-text'}>
								{formatMessage(
									{id: 'team_modal.seats_warning_action_prevented'},
									{type: 'virtual ', max: `(${virtualSeats})`}
								)}
								<Link onClick={this.handleLinkClick.bind(this)} to="/settings/subscription">
									{formatMessage({id: 'team_modal.seats_warning_subscription_page'})}
								</Link>
							</div>
						</div>
					</div>
				);
			}

			return (
				<div className={'seats-count info'}>
					<div className={'seats-text'}>
						{formatMessage({id: 'team_modal.seats_info'}, {amount: actualUserSeats, total: userSeats})}
					</div>
					{!freeVirtualUsers ? (
						<div className={'seats-text'}>
							{formatMessage(
								{id: 'team_modal.virtual_seats_info'},
								{amount: actualVirtualSeats, total: virtualSeats}
							)}
						</div>
					) : null}
				</div>
			);
		} else if (this.state.selectedPermission === permissions[0].value) {
			return (
				<div className={'seats-count warning'}>
					<div className={'seats-text'}>
						<div className={'seats-text'}>
							<div className={'seats-warning-text'}>
								{formatMessage({id: 'add_team_member_modal.disclaimer'})}
							</div>
						</div>
					</div>
				</div>
			);
		}
	}

	createdPersonsRow(p, index) {
		const {formatMessage} = this.props.intl;
		const sortedProfiles = getSelectableProfiles(this.props.viewer.company.profiles.edges);
		const profileOptions = sortedProfiles.map(profile => {
			return {label: profile.name, value: profile.id, profile: profile};
		});

		return (
			<div className={'add-team-member-modal-content'} key={p.email}>
				<InputField
					label={formatMessage({id: 'add_team_member_modal.full-name'})}
					hideLabel={index !== 0}
					value={p.name}
					type="text"
					locked={true}
				/>
				<InputField
					label={formatMessage({id: 'common.email'})}
					hideLabel={index !== 0}
					value={p.email}
					type="email"
					locked={true}
				/>
				<Dropdown
					options={this.props.viewer.company.roles.edges.map(role => {
						return {value: role.node.id, label: role.node.name};
					})}
					label={formatMessage({id: 'add_team_member_modal.main-role'})}
					hideLabel={index !== 0}
					disabled={true}
					value={p.role}
					customWidth={190}
					onChange={() => false}
				/>
				<Dropdown
					options={profileOptions}
					value={p.profile.value}
					label={formatMessage({id: 'common.permission'})}
					hideLabel={index !== 0}
					disabled={true}
					customWidth={190}
					onChange={() => false}
				/>
				<div className={'invited-success'}>
					<div className={'success-text'}>INVITED</div>
				</div>
			</div>
		);
	}

	render() {
		const {formatMessage} = this.props.intl;

		const sortedProfiles = getSelectableProfiles(this.props.viewer.company.profiles.edges);
		const profileOptions = sortedProfiles.map(profile => {
			return {label: profile.name, value: profile.id, profile: profile};
		});
		const showHeader = this.state.createdPersons.length === 0;

		let overUserCap;
		let overVirtualUserCap;

		const isChargebeeCustomer = this.props.viewer.company.isChargebeeCustomer;
		// All active
		const activated = this.props.viewer.company.allPersons.edges.filter(person => person.node.active).map(p => p.node);

		if (isChargebeeCustomer) {
			// Seats from chargebee subscription
			const userSeats = this.props.viewer.company.subscription
				? this.props.viewer.company.subscription.seats
				: this.props.viewer.company.userSeats;
			const virtualSeats = this.props.viewer.company.subscription
				? this.props.viewer.company.subscription.virtualSeats
				: this.props.viewer.company.virtualSeats;

			// How many active seats the account actual has
			const actualUserSeats = activated.filter(
				person => !personIsVirtualUser(person) && !personIsClientUser(person)
			).length;
			const actualVirtualSeats = activated.filter(person => personIsVirtualUser(person)).length;

			// If account is going above its seats
			overUserCap = userSeats <= actualUserSeats;

			const freeVirtualUsers = this.props.viewer.company.planAddons.some(pa => pa === 'free_virtual_users');
			overVirtualUserCap = !freeVirtualUsers && virtualSeats <= actualVirtualSeats;
		}

		const blockPersonCreation =
			(overUserCap && this.state.selectedProfile && !personIsVirtualUser(this.state.selectedProfile.profile)) ||
			(overVirtualUserCap && this.state.selectedProfile && personIsVirtualUser(this.state.selectedProfile.profile));

		return (
			<div className={'add-team-member-modal'}>
				{<div className={'seats-count-info'}>{this.getSeatsInfoWithProfile()}</div>}
				{this.state.createdPersons.map((p, index) => this.createdPersonsRow(p, index))}
				<div className={'add-team-member-modal-content'}>
					<InputField
						label={formatMessage({id: 'add_team_member_modal.full-name'})}
						hideLabel={!showHeader}
						value={this.state.name}
						onChange={this.handleInputChange.bind(this, 'name')}
						autoFocus={true}
						type="text"
						placeholder=""
						invalidInput={this.state.showNameValidationError}
						errorMessage={this.state.nameValidationErrorMessage}
						cy={'name-input-field'}
					/>
					<InputField
						label={formatMessage({id: 'common.email'})}
						hideLabel={!showHeader}
						value={this.state.email}
						onChange={this.handleInputChange.bind(this, 'email')}
						type="email"
						placeholder=""
						checkEmailValidity={this.checkEmailValidity.bind(this)}
						invalidInput={this.state.showEmailValidationError}
						errorMessage={this.state.emailValidationErrorMessage}
						shouldFocus={this.state.showEmailValidationError}
						autoFocus={false}
						cy={'email-input-field'}
					/>
					<Dropdown
						options={this.props.viewer.company.roles.edges.map(role => {
							return {value: role.node.id, label: role.node.name};
						})}
						onChange={this.handleSelectChange.bind(this, 'selectedRole')}
						value={this.state.selectedRole}
						multi={false}
						label={formatMessage({id: 'add_team_member_modal.main-role'})}
						hideLabel={!showHeader}
						clearable={true}
						inputName={'role-input'}
						dataCy={'role-input-select'}
						customWidth={190}
						listDataCy={'role'}
					/>
					<Dropdown
						options={profileOptions}
						onChange={this.handleProfileChange.bind(this)}
						value={this.state.selectedProfile?.value}
						multi={false}
						label={formatMessage({id: 'common.permission'})}
						hideLabel={!showHeader}
						inputName={'permission-input'}
						dataCy={'permission-input-select'}
						invalidInput={this.state.showUserTypeValidationError}
						errorMessage={this.state.userTypeValidationErrorMessage}
						onFocus={this.clearValidation.bind(this)}
						customWidth={190}
						listDataCy={'permission'}
					/>
					<Button
						cy={'invite-new-button'}
						className={'invite-new'}
						isDisabled={blockPersonCreation}
						key={'create-new-btn'}
						text={formatMessage({id: 'common.invite'}).toUpperCase()}
						buttonStyle={BUTTON_STYLE.FILLED}
						colorTheme={BUTTON_COLOR.GREEN}
						onClick={blockPersonCreation ? undefined : this.createPersonFromProfile.bind(this)}
						onKeyDown={blockPersonCreation ? undefined : this.createPersonFromProfile.bind(this)}
					/>
				</div>
			</div>
		);
	}
}

AddTeamMemberModalContent.propTypes = {
	closeModal: PropTypes.func,
	buttonLocation: PropTypes.string.isRequired,
	projectId: PropTypes.string,
	projectGroupId: PropTypes.string,
};

export default injectIntl(AddTeamMemberModalContent);
